import React from 'react';
import './styles.css';

export interface FloatingAction {
  key: string;
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
}

interface FloatingActionsProps {
  actions: FloatingAction[];
}

const FloatingActions: React.FC<FloatingActionsProps> = ({ actions }) => (
  <div className="floating-actions">
    {actions.map((action) => (
      <button
        key={action.key}
        type="button"
        className="floating-action-button"
        onClick={action.onClick}
      >
        {action?.icon && <span className="floating-action-icon">{action.icon}</span>}
        <span className="floating-action-label">{action.label}</span>
      </button>
    ))}
  </div>
);

export default FloatingActions;